import TableContainer from './TableContainer';
import React from 'react';
import { IGetCaseListItem } from 'src/state/slice/models/CaseLifecycleTypes';
import styled from 'styled-components';

const CaseListTableContainer = styled.div`
  margin-top: 1rem;
`;
export interface CaseListTableProps {
  data: Array<IGetCaseListItem>;
}
const CaseListTable: React.FC<CaseListTableProps> = ({ data }) => {
  return (
    <CaseListTableContainer>
      <TableContainer data={data} />
    </CaseListTableContainer>
  );
};

export default CaseListTable;
